// @ts-check
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { TestableText, TestableButton } from './TestableComponents';
import { CARD_TYPES, ErrorCard } from "@components/cards/ErrorCard";

export default function ProjectNotFound() {
    const navigate = useNavigate();
    
    return (
        <div data-testid="project-not-found" className="mt-1 p-3 sm:p-5 bg-gray-50 dark:bg-dark-tremor-background-muted rounded-lg border dark:border-dark-tremor-border mx-auto text-center max-w-2xl">
             <ErrorCard cardType={CARD_TYPES.EMPTY} />
             <TestableText dataTestId="pnf-main-title" variant="h3" className="w-full mt-5 text-center text-blue-500">
                Project Not Found
              </TestableText>
              <TestableText dataTestId="pnf-body-text" variant="paragraph" className="w-full text-center mt-2 mb-6 text-gray-600 dark:text-gray-300">
                The project you are looking for could not be found. It may have been deleted, disabled, or you may not have permission to view it.
              </TestableText>
              <TestableButton dataTestId="pnf-home-button" color="blue" onClick={() => navigate('/home')}>Return Home</TestableButton>
        </div>
    );
}